import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { editFormInput, getInputData } from '../store/forms';
import CheckBox from './CheckBox';
import TerminosyCondiciones from './TerminosyCondiciones';
import PaperWrapper from './PaperWrapper';

function ConsentForm() {
	const view = "checkin2";
  const object = "consent";
  const condiciones = useSelector(getInputData(view, object, "condiciones"));
  const datosVeridicos = useSelector(getInputData(view, object, "datosVeridicos"));
  
  const dispatch = useDispatch();
  const handleChangeValue = (id, value) => {
    dispatch(editFormInput({ data: value, object, input: id, view }));
  };
  const handleChange = (id, value) => {
    handleChangeValue(id, value);
  };
  return (
        <Stack sx={{ height: '100%' }} >
          <Stack direction="row">
            <CheckBox control={condiciones} handleChange={(v) => handleChange("condiciones", v)}  />
            <TerminosyCondiciones />
          </Stack>
          <CheckBox control={datosVeridicos} handleChange={(v) => handleChange("datosVeridicos", v)}  />
        </Stack>
  );
}

export default ConsentForm;